/**
 * Rate limiter simple para el frontend.
 * Limita la cantidad de intentos por acción en una ventana de tiempo.
 */
const attempts = {};

/**
 * Verifica si una acción está permitida o si se ha excedido el límite.
 * @param {string} key - Identificador de la acción (ej: "login", "contact")
 * @param {number} maxAttempts - Máximo de intentos permitidos
 * @param {number} windowMs - Ventana de tiempo en milisegundos
 * @returns {{ allowed: boolean, remainingMs: number }} - Si está permitido y ms restantes de bloqueo
 */
export const checkRateLimit = (key, maxAttempts = 5, windowMs = 60000) => {
  const now = Date.now();

  if (!attempts[key]) {
    attempts[key] = [];
  }

  // Limpiar intentos fuera de la ventana
  attempts[key] = attempts[key].filter((t) => now - t < windowMs);

  if (attempts[key].length >= maxAttempts) {
    const oldestInWindow = attempts[key][0];
    const remainingMs = windowMs - (now - oldestInWindow);
    return { allowed: false, remainingMs };
  }

  attempts[key].push(now);
  return { allowed: true, remainingMs: 0 };
};

/**
 * Resetea los intentos de una acción (útil tras éxito).
 */
export const resetRateLimit = (key) => {
  delete attempts[key];
};
